<script setup lang="ts">
import PermalinkPage from '~/pages/[...permalink].vue'
</script>

<template>
  <PermalinkPage />
</template>
